<template>
  <form role="form">
    <div class="box-body">
      <div class="form-group">
        <label for="name">Nome</label>
        <input type="text" class="form-control" id="name" placeholder="Entre com o nome da empresa" v-model="company.name">
        <p v-if="errors.name" class="text-red">{{ errors.name }}</p>
      </div>
      <div class="form-group">
        <label for="cnpj">Cnpj</label>
        <the-mask
        :mask="['##.###.###/####-##']"
        id="cnpj"
        type="text"
        :masked="true"
        placeholder="Entre com o Cnpj"
        class="form-control"
        v-model="company.cnpj"
        />
        <p v-if="errors.cnpj" class="text-red">{{ errors.cnpj }}</p>
      </div>
      <div class="row">
        <div class="col-md-6">
          <div class="form-group">
            <label for="parkEntryYear">Ano de Ingresso no Parque</label>
            <select id="parkEntryYear" class="form-control" v-model="company.parkEntryYear">
              <option selected="selected" :value="1"></option>
              <option v-for="year in getYearsRange">{{ year }}</option>
            </select>
            <p v-if="errors.parkEntryYear" class="text-red">{{ errors.parkEntryYear }}</p>
          </div>
        </div>
        <div class="col-md-6">
          <div class="form-group">
            <label for="creationDate">Data de Criação da Empresa</label>
            <DatePicker
              id="creationDate"
              placeholder="Selecione a data"
              :bootstrapStyling="true"
              :language="datepickerLanguage"
              :value="getCreationDateAsDateObject()"
              @selected="onCreationDateSelected">
            </DatePicker>
            <p v-if="errors.creationDate" class="text-red">{{ errors.creationDate }}</p>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-xs-12">
          <div class="form-group">
          <label>Áreas de Atuação</label>
            <div v-for="area in areasOfExpertise">
              <label class="checkbox-inline">
                <input type="checkbox" :value="area" v-model="company.areasOfExpertise">
                <span>{{ area }}</span>
              </label>
            </div>
            <p v-if="errors.areasOfExpertise" class="text-red">{{ errors.areasOfExpertise }}</p>
          </div>
        </div>
      </div>
      <fieldset>
        <legend>Endereço</legend>
        <div class="form-group">
          <label for="street">Rua</label>
          <input type="text" class="form-control" id="street" placeholder="Entre com a rua" v-model="company.street">
          <p v-if="errors.street" class="text-red">{{ errors.street }}</p>
        </div>
        <div class="row">
          <div class="col-md-6">
            <div class="form-group">
              <label for="neighborhood">Bairro</label>
              <input type="text" class="form-control" id="neighborhood" placeholder="Entre com o bairro" v-model="company.neighborhood">
              <p v-if="errors.neighborhood" class="text-red">{{ errors.neighborhood }}</p>
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <label for="number">Número</label>
              <input type="number" class="form-control" id="number" placeholder="Entre com o número" v-model="company.number">
              <p v-if="errors.number" class="text-red">{{ errors.number }}</p>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6">
            <div class="form-group">
              <label for="state">Estado</label>
              <model-select
                :options="states"
                v-model="company.state"
                id="state"
                class="form-control"
                placeholder="Entre com o estado"
                :custom-attr="customSelectItemClass"
              />
              <p v-if="errors.state" class="text-red">{{ errors.state }}</p>
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <label for="city">Cidade</label>
              <model-select
                :options="cities"
                v-model="company.city"
                id="city"
                class="form-control"
                placeholder="Entre com a cidade"
                :custom-attr="customSelectItemClass"
              />
              <p v-if="errors.city" class="text-red">{{ errors.city }}</p>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6">
            <div class="form-group">
              <label for="postalCode">CEP</label>
              <the-mask
              :mask="['#####-###']"
              id="postalCode"
              type="text"
              :masked="true"
              placeholder="Entre com o CEP"
              class="form-control"
              v-model="company.postalCode"
              />
              <p v-if="errors.postalCode" class="text-red">{{ errors.postalCode }}</p>
            </div>
          </div>
        </div>
      </fieldset>
      <fieldset>
        <legend>Contato</legend>
        <div class="form-group">
          <label for="email">Email</label>
          <input type="email" class="form-control" id="email" placeholder="Entre com o email" v-model="company.email">
          <p v-if="errors.email" class="text-red">{{ errors.email }}</p>
        </div>
        <div class="form-group">
          <label for="phoneNumber">Telefone</label>
          <the-mask
          :mask="['(##) ####-####', '(##) #####-####']"
          id="phoneNumber"
          type="text"
          :masked="true"
          placeholder="Entre com o telefone"
          class="form-control"
          v-model="company.phoneNumber"
          />
          <p v-if="errors.phoneNumber" class="text-red">{{ errors.phoneNumber }}</p>
        </div>
      </fieldset>
      <fieldset>
        <legend>Logo</legend>
        <div class="text-center">
          <img v-if="this.company['id'] !== undefined" :src="company.logoPicture"/>
        </div>
        <vue-base64-file-upload
        class="text-center"
        accept="image/png,image/jpeg"
        image-class="v1-image"
        input-class="v1-input"
        :max-size="customImageMaxSize"
        :placeholder="'Clique para fazer o upload do logo'"
        :disable-preview="this.company['id'] !== undefined"
        @size-exceeded="onSizeExceeded"
        @load="onLoad" />
      </fieldset>
    </div>
    <div class="box-footer">
      <button type="submit" class="btn btn-primary pull-right" v-on:click.prevent="onSubmit">Salvar</button>
      <go-back-button></go-back-button>
    </div>
  </form>
</template>

<script>
import TheMask from 'vue-the-mask'
import GoBackButton from '@/components/elements/GoBackButton'
import VueBase64FileUpload from 'vue-base64-file-upload'
import { ModelSelect } from 'vue-search-select'
import DatePicker from 'vuejs-datepicker'
import { ptBR } from 'vuejs-datepicker/dist/locale'
import DateFormatter from '@/services/date_formatter'
import brazilCitiesByStateInitials from '../../assets/json/brazil-cities-by-state-initials.json'

export default {
  name: 'CompanyForm',
  components: { TheMask, GoBackButton, VueBase64FileUpload, ModelSelect, DatePicker },
  props: ['company', 'errors', 'onSubmit'],
  data () {
    return {
      datepickerLanguage: ptBR,
      customImageMaxSize: 3,
      areasOfExpertise: [
        'Aeronáutico',
        'Agronegócio',
        'Alimentos',
        'Automotiva',
        'Biotecnologia',
        'De suporte à C, T & I',
        'Economia criativa',
        'Eletrônica',
        'Energia',
        'Espacial',
        'Meio ambiente',
        'Mineral',
        'Petróleo e gás natural',
        'Química',
        'Recursos hídricos',
        'Saúde animal',
        'Saúde humana',
        'Tecnologia da informação',
        'Telecomunicações',
        'Transporte aquaviario e construção naval',
        'Transporte terrestre e hidroviário'
      ]
    }
  },
  mounted () {
    if (!this.company.hasOwnProperty('areasOfExpertise')) {
      this.company.areasOfExpertise = []
    }

    $('#state').attr('autocomplete', 'disable-state-field-autocomplete')
    $('#city').attr('autocomplete', 'disable-city-field-autocomplete')
  },
  methods: {
    onLoad (dataUri) {
      this.company.logoPicture = dataUri
    },
    onSizeExceeded (size) {
      alert(`Image ${size}Mb size exceeds limits of ${this.customImageMaxSize}Mb!`)
    },
    customSelectItemClass () {
      return 'search-select-item'
    },
    onCreationDateSelected (date) {
      this.company.creationDate = DateFormatter.formatAPIDate(date)
    },
    getCreationDateAsDateObject () {
      if (!this.company.creationDate) {
        return null
      }
      return new Date(this.company.creationDate.split('-'))
    }
  },
  computed: {
    getYearsRange () {
      let currentYear = new Date().getFullYear()
      let startYear = 1990
      let years = []
      while (currentYear >= startYear) {
        years.push(currentYear--)
      }

      return years
    },
    states: function () {
      return Object.keys(brazilCitiesByStateInitials).map((e) => ({
        value: e, text: brazilCitiesByStateInitials[e].name
      }))
    },
    cities: function () {
      if (!this.company.state) {
        return []
      }
      const cities = brazilCitiesByStateInitials[this.company.state].cities
      return cities.map((e) => ({value: e, text: e}))
    }
  }
}
</script>

<style>
  .item[data-vss-custom-attr="search-select-item"] {
    font-size: 14px !important;
  }
</style>



// WEBPACK FOOTER //
// CompanyForm.vue?62ec7115